import React from 'react';
// import logo from '../../assets/images/logos/1.svg'
import { Link } from 'react-router-dom';
import { resetPreSelectedFilters } from '@common/utils/utils';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function SectionBanner({ btnLink, btnText, title, desc, link, imageUrl, clientlogo, noHover, titlePosition, view, variant, titleLine1, titleLine2, redirectionLink = "" }) {


  return (
    <div className={`
      bs-section-banner 
      ${clientlogo ? 'bs-section-banner--typ-full-height' : ''} 
      ${noHover ? 'bs-section-banner--no-hover-interaction' : ''} 
      ${view === 'sm' ? 'bs-section-banner--info-small' : ''}
      ${titlePosition === 'on-image' ? 'bs-section-banner--on-image' : ''}
      ${variant === 'typ-2' ? 'bs-section-banner--variant-typ-2' : ''}
      ${variant === 'typ-3' ? 'bs-section-banner--variant-typ-3' : ''}
      ${variant === 'typ-display-link' ? 'bs-section-banner--variant-typ-display-link' : ''}
       ${variant === 'typ-4' ? 'bs-section-banner--variant-typ-4' : ''}
    `}>
      {variant === 'typ-4' ? (
        <>
          <div className='bs-section-banner__title-wrap'>
            <h3 className='bs-section__title'>
              <span className="bs-section__title__font-2-text--sm" dangerouslySetInnerHTML={{ __html: titleLine1 }}></span>
              <span className="bs-section__title__font-2-text--lg" dangerouslySetInnerHTML={{ __html: titleLine2 }}></span>
            </h3>
          </div>
          <div className='bs-section-banner__media-wrap'>
            <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-section-banner__image' type="original" />
          </div>
          <div className='bs-section-banner__info-wrap'>
            <div className='bs-section-banner__desc-wrap'>
              <p className='bs-section__desc' dangerouslySetInnerHTML={{ __html: desc }}></p>
            </div>
            <Link
              to={btnLink}
              className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-large bs-section-banner__action'
            >
              {btnText}
            </Link>
          </div>
        </>
      ) : variant === 'typ-2' ? (
        <>
          {(titleLine1 !== null || titleLine1 !== '') && (titleLine2 !== null || titleLine2 !== '') ? (
            <div className='bs-section-banner__title-wrap'>
              <h3 className='bs-section__title'>
                <span className="bs-section__title__font-1-text--sm" dangerouslySetInnerHTML={{ __html: titleLine1 }}></span>
                <span className="bs-section__title__font-1-text--lg" dangerouslySetInnerHTML={{ __html: titleLine2 }}></span>
              </h3>
            </div>
          ) : null}
          <div className='bs-section-banner__media-wrap'>
            <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-section-banner__image' type="original" />
          </div>
        </>
      ) : variant === 'typ-3' ? (
        <>
          <div className='bs-section-banner__media-wrap'>
            <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-section-banner__image' type="original" />
          </div>
          <div className='bs-section-banner__info-wrap'>
            <div className='bs-section-banner__desc-wrap'>
              <h3 className='bs-section__title'>{title}</h3>
              <p className='bs-section__desc' dangerouslySetInnerHTML={{ __html: desc }}></p>
            </div>
            <a
              href="https://shop.sansaar.co.in/collections/all-bedding"
              className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--inverse bs-section-banner__action'
              onClick={(e) => {
                resetPreSelectedFilters();
                localStorage.setItem("filterValue", "ORIGINS");
                localStorage.setItem("filterKey", "collectionName");
              }}
            >
              shop Collection
            </a>
          </div>
        </>
      ) : variant === 'typ-display-link' ? (
        <>
          <div className='bs-section-banner__media-wrap'>
            <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-section-banner__image' type="original" />
            <a
              href={redirectionLink.startsWith('http') ? redirectionLink : "https://shop.sansaar.co.in/collections/all-bedding"}
              onClick={(e) => {
                resetPreSelectedFilters();
                localStorage.removeItem("filterValue");
                localStorage.removeItem("filterKey");
              }}
              className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--inverse bs-btn__btn-solid--typ-large bs-section-banner__action'
            >
              shop now
            </a>
          </div>
        </>
      ) : (
        <>
          {titlePosition === 'top' ? (
            <div className='bs-section-banner__title-wrap'>
              <h3 className='bs-section__title'>{title}</h3>
            </div>
          ) : null}
          {/* {imageUrl ? ( */}
          <div className='bs-section-banner__media-wrap'>
            <CloudinaryAdvancedImage imagePublicId={imageUrl} className='bs-section-banner__image' type="original" />
          </div>
          {/* ) : null} */}
          <div className='bs-section-banner__info-wrap'>
            {titlePosition === 'top' ? null : <h3 className='bs-section__title' dangerouslySetInnerHTML={{ __html: title }}></h3>}
            <div className='bs-section-banner__desc-wrap' style={{ marginBlockEnd: '2rem' }}>
              <p className='bs-section__desc' style={{ textAlign: 'left' }}>{desc}</p>
            </div>
            {clientlogo &&
              <div className='lyt-logo'>
                {clientlogo.map((logo, index) => {
                  return (
                    <div className='lyt-logo__img-wrap' key={index}>
                      <img src={logo.src} alt={logo.name} loading="lazy" decoding="async" />
                    </div>
                  )
                })}
              </div>
            }
            {link && <a href={link} className='bs-btn bs-btn__btn-solid'>learn more</a>}
          </div>
        </>
      )}


    </div>
  )
}

export default SectionBanner